import React, { Fragment, Component } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import ClientTable from "./components/table";
import Service from "../../services/clientService";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import $ from "jquery";
// import store from "store";

class CreateClient extends Component {
  state = {
    infoData: [],
    info: { sUrl: "" },
    page: 0,
    pageSize: 10,
    totalRecords: 0,
    loading: false,
  };
  componentWillMount() {
    const { match } = this.props;
    const { params } = match;
    const { clientStatus } = params;
    this.setState({ loader: true, clientStatus }, function () {
      this.callApiInfo();
    });
  }

  componentDidUpdate() {
    const { match } = this.props;
    const { params } = match;
    const { clientStatus } = params;
    if (this.state.clientStatus !== clientStatus) {
      this.setState(
        {
          loader: true,
          infoData: [],
          searchText: "",
          page: 0,
          pageSize: 10,
          totalRecords: 0,
          startDate: "",
          endDate: "",
          clientStatus: clientStatus,
        },
        function () {
          this.callApiInfo();
        }
      );
    }
  }

  callApiInfo = () => {
    const {
      clientStatus,
      page,
      pageSize,
      searchText,
      startDate,
      endDate,
    } = this.state;
    Service.fetchClientsInfo(
      undefined,
      clientStatus,
      page,
      pageSize,
      searchText,
      startDate,
      endDate
    ).then((response) => {
      if (!response.error) {
        var totalRecords = Math.ceil(response?.data?.totalRecords / pageSize);
        console.log({ response: response?.data });
        this.setState({
          modalFormShow: false,
          loader: false,
          infoData: response?.data?.clients,
          totalRecords: totalRecords,
        });
      } else {
        this.setState({
          loader: false,
          infoData: [],
          totalRecords: 0,
        });
      }
    });
    this.setState({ loader: false });
  };
  onClickToggle = () => {
    this.setState({ modalFormShow: false });
  };
  onSearchText = (searchText) => {
    this.setState(
      {
        page: 0,
        searchText: searchText,
        startDate: "",
        endDate: "",
      },
      function () {
        if (searchText && searchText !== "" && searchText.length > 0) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };
  onSearchDate = (startDate, endDate) => {
    this.setState(
      {
        page: 0,
        searchText: "",
        startDate: startDate,
        endDate: endDate,
      },
      function () {
        if (startDate && endDate) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };
  onChangePageSize = (pageSize) => {
    this.setState(
      {
        pageSize: pageSize,
      },
      function () {
        if (pageSize) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };
  onChangePage = (page) => {
    this.setState(
      {
        page: page,
      },
      function () {
        $.ajaxQ.abortAll();
        this.callApiInfo();
      }
    );
  };
  onChangeImage = (imageUrl) => {
    this.setState({ imageUrl: imageUrl });
  };

  removeImage = () => {
    this.setState({ imageUrl: undefined });
  };

  onChangeUrl = (name, url) => {
    if ((name && name !== "") || (url && url !== "")) {
      console.log({ url });
      var { info, urlEdit } = this.state;
      var stringUrl = "";
      var urlEdit1 = false;
      if (name && !urlEdit) {
        stringUrl = name.toLowerCase();
      } else if (url) {
        stringUrl = url.toLowerCase();
        urlEdit1 = true;
      }
      stringUrl = stringUrl.replace(/ /g, "_");
      stringUrl = stringUrl.replace(/,/g, "_");
      stringUrl = stringUrl.replace(/__/g, "_");
      if (info) {
        info["sUrl"] = stringUrl;
      } else {
        info = { sUrl: stringUrl };
      }
      this.setState({ info: info, urlEdit: urlEdit1 });
    }
  };

  // onChangeActive = (clientId, value, index) => {
  //   console.log({ clientId, value });
  //   const { infoData } = this.state;
  //   this.setState({ loader: true });
  //   Service.onClientReady(clientId, value).then((response) => {
  //     if (!response.error) {
  //       infoData[index].public = value;
  //       this.setState({ infoData, loader: false });
  //       // this.props.history.push("/products/all");
  //     }
  //     this.setState({ loader: false });
  //   });
  // };

  onChangeActive = (clientId, isApproved, index) => {
    console.log({ clientId, isApproved });
    const { infoData } = this.state;
    this.setState({ loader: true });
    Service.onClientStatus(clientId, isApproved).then((response) => {
      if (!response.error) {
        infoData[index].isApproved = isApproved;
        infoData[index].staffMemberId = "123";
        this.setState({ infoData, loader: false });
        // this.props.history.push("/products/all");
      }
      this.setState({ loader: false });
    });
  };
  render() {
    const {
      clientStatus,
      infoData,
      modalFormShow,
      loader,
      info,
      index,
      isEdit,
      imageUrl,
    } = this.state;
    const { loading, page, pageSize, totalRecords } = this.state;

    const propsTable = {
      clientStatus: clientStatus,
      multiSelectOption: false,
      myData: infoData,
      loading: loading,
      pageSize: pageSize,
      page: page,
      totalRecords: totalRecords,
      // pageSize: infoData.length < 10 ? infoData.length : 10,
      pagination: true,
      onChangeActive: this.onChangeActive,
      onEditInfo: (index, info) => {
        this.props.history.push("/categories/" + info._id + "/update");
        // this.setState({
        //   modalFormShow: true,
        //   isEdit: true,
        //   info,
        //   imageUrl: info.imageUrl,
        // });
      },
      onChangePageSize: (pageSize) => {
        //console.log({ pageSize });
        this.onChangePageSize(pageSize);
      },
      onChangePage: (page) => {
        this.onChangePage(page);
      },
      deactivateMember: (staffMemberId) => {
        this.memberDeactivate(staffMemberId);
      },
      handleInfoEdit: (info) => {
        //console.log({info})
        this.dealerInfoEdit(info);
      },
    };
    return (
      <Fragment>
        <Breadcrumb title={clientStatus} parent="Client" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card border-0" style={{boxShadow:"1px 5px 24px 0 rgba(68, 102, 242, .05)"}}>
                {/* <div className="card-header">
                  <h5>Select Multiple Data</h5>
                </div> */}

                {loader && (
                  <div
                    style={{
                      position: "fixed",
                      top: "50%",
                      right: "45%",
                      zIndex: "+999",
                    }}
                  >
                    <div className="loader bg-white">
                      <div className="whirly-loader"> </div>
                    </div>
                  </div>
                )}
                <div className="card-body datatable-react" style={{padding:"30px"}}>
                  <div className="row m-b-10">
                    <div className="col-sm-4"></div>
                    <div className="col-sm-4">
                      {/* <Search {...propsSearchText} /> */}
                    </div>

                    <div className="col-sm-4" style={{ marginTop: "10px" }}>
                      {/* <DateRangePicker {...propsDaterangePicker} /> */}
                    </div>
                  </div>
                  {/* {infoData && infoData.length > 0 && ( */}
                  <ClientTable
                    {...propsTable}
                    className="-striped -highlight"
                  />
                  {/* )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default CreateClient;
